// extracted by mini-css-extract-plugin
export var fulfillmentPanel = "_g6-0";
export var fulfillmentPanelBody = "_g6-1";